<template>
  <main class="app-content" :short="true">
    <div class="m-5 pt-5">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <audience-admin-dashboard></audience-admin-dashboard>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import AudienceAdminDashboard from '../../components/Audience/Admin/AudienceAdminDashboard.vue';
export default {
  components: {
    AudienceAdminDashboard,
  },
};
</script>
